import request from '@/config/config'

// 获取token
export function getToken (query) {
  return request({
    url: '/controllerApi/1.0/userPermission/common/getToken',
    method: 'get',
    params: query
  })
}

// 获取图形验证码
export function getCode (query) {
  return request({
    url: '/controllerApi/1.0/userPermission/common/getValidateCode',
    method: 'get',
    params: query,
    responseType: 'arraybuffer'
  })
}

// 登录
export function loginByUsername (data) {
  return request({
    url: '/controllerApi/1.0/userPermission/project/login/doLogin',
    method: 'post',
    data
  })
}

// 首次登录修改密码
export function updateUserPassword (data) {
  return request({
    url: '/controllerApi/1.0/userPermission/user/updateUserPassword',
    method: 'post',
    data
  })
}

// 获取联网单位列表
export function getSystemProjectList (data) {
  return request({
    url: '/controllerApi/1.0/project/manage/getSystemProjectList',
    method: 'POST',
    data
  })
}

// 取消用户隐私条款
export function noPrivacyAgreement (query) {
  return request({
    url: '/controllerApi/1.0/userPermission/user/noPrivacyAgreement',
    method: 'get',
    params: query
  })
}

// 获取用户密码（加密后的密码）
export function getUserPassword (query) {
  return request({
    url: '/controllerApi/1.0/userPermission/user/getUserPassword',
    method: 'get',
    params: query
  })
}
// 查询最新消息通知
export function getNewPublishMsg (data) {
  return request({
    url: '/controllerApi/1.0/news/publishMsg/getNewPublishMsg',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/common.js